import { LitElement, html } from 'lit';
import '../icons/info-icon.js';

/**
 * @component payment-bank-transfer
 * @description Bank transfer details card — displays bank account info and payment reference.
 *
 * @property {String} quoteReference - Quote reference number
 * @property {String} totalAmount - Formatted total (e.g. "$759.00")
 * @property {String} bankAccount - Bank account number
 * @property {String} bankAddress - Bank name/address
 */
class PaymentBankTransfer extends LitElement {
    static properties = {
        quoteReference: { type: String },
        totalAmount: { type: String },
        bankAccount: { type: String },
        bankAddress: { type: String },
    };

    createRenderRoot() {
        return this;
    }

    constructor() {
        super();
        this.quoteReference = '';
        this.totalAmount = '$0.00';
        this.bankAccount = 'N/A';
        this.bankAddress = 'N/A';
    }

    render() {
        return html`
            <div class="card bg-base-200">
                <div class="card-body">
                    <h3 class="card-title text-xl mb-4">Bank Transfer</h3>

                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <p class="text-sm text-gray-600 mb-1">Bank</p>
                            <p class="font-bold text-lg">${this.bankAddress}</p>
                        </div>
                        <div>
                            <p class="text-sm text-gray-600 mb-1">Account Number</p>
                            <p class="font-bold text-lg">${this.bankAccount}</p>
                        </div>
                        <div>
                            <p class="text-sm text-gray-600 mb-1">Amount to Pay</p>
                            <p class="font-bold text-2xl text-peppermint">${this.totalAmount}</p>
                        </div>
                        <div>
                            <p class="text-sm text-gray-600 mb-1">Reference</p>
                            <p class="font-bold text-lg">${this.quoteReference}</p>
                        </div>
                    </div>

                    <div class="alert alert-row alert-info mt-6">
                        <info-icon class="shrink-0"></info-icon>
                        <span class="text-sm text-left">
                            Please include the quote reference
                            <strong>${this.quoteReference}</strong> in your payment description so
                            we can process your booking quickly.
                        </span>
                    </div>
                </div>
            </div>
        `;
    }
}

customElements.define('payment-bank-transfer', PaymentBankTransfer);
